/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { Resource } from '@ngxp/rest';
import { InstantSearchResult, SearchResultItemComponent } from '@ods/system';
import { SearchZustaendigeStelleFormservice } from '../../search-zustaendige-stelle.formservice';
import { SearchZustaendigeStelleResultItemsComponent } from './search-zustaendige-stelle-result-items/search-zustaendige-stelle-result-items.component';

@Component({
  selector: 'alfa-search-zustaendige-stelle-form',
  templateUrl: './search-zustaendige-stelle-form.component.html',
  providers: [SearchZustaendigeStelleFormservice],
  standalone: false,
})
export class SearchZustaendigeStelleFormComponent<T extends Resource> implements AfterViewInit {
  public readonly formService = inject(SearchZustaendigeStelleFormservice);
  readonly _cdr = inject(ChangeDetectorRef);

  @Input() public instantSearchResults: InstantSearchResult<T>[];
  @Input() public label: string;
  @Input() public focusOnSearchField: boolean = false;

  @Output() public searched: EventEmitter<string> = new EventEmitter();
  @Output() public selectSearchResult: EventEmitter<T> = new EventEmitter();
  @Output() public clearSearchResult: EventEmitter<string> = new EventEmitter();

  @ViewChild(SearchZustaendigeStelleResultItemsComponent) searchResultItemsComp: SearchZustaendigeStelleResultItemsComponent<T>;

  public searchResultItemList: QueryList<SearchResultItemComponent>;

  ngAfterViewInit() {
    this.searchResultItemList = this.searchResultItemsComp.searchResultItemList;
    this._cdr.detectChanges();
  }
}
